import { type ActiveState, createEntityStore, type EntityState } from '@datorama/akita';
import { type KpiScope } from 'types/models';

export interface KPIScopesState extends EntityState<KpiScope>, ActiveState {
   pendingUploads: {
      kpiScopeId: number;
      [key: string]: any;
   }[];
   pendingDeletions: any[];
   [key: string]: any;
}

const store = createEntityStore<KPIScopesState>({ pendingUploads: [], pendingDeletions: [] }, { resettable: true, name: 'kpiScopes' });

export default store;
